import { typographyStyles, constants } from "@newsela/angelou";

const { heading5Obj, textSObj } = typographyStyles;
const {
  colors,
  colors: { ui },
} = constants;

const cleverBGColor = "#416FE4";
const canvasBGColor = "#E12D23";
const classlinkBGColor = "#204D7B";

export const sectionDividerCss = {
  display: "flex",
  flexDirection: "row",
  margin: "12px 0",
  marginBottom: 20,
  strong: {
    ...textSObj,
    color: ui.neutral[400],
  },
  hr: {
    flex: 1,
    alignSelf: "center",
    border: "none",
    borderBottom: `1px solid ${ui.neutral[100]}`,
    margin: "0 15px",
  },
};

export const anchorWrapperCss = {
  display: "grid",
  gridGap: "16px",
  gridTemplateColumns: "repeat(auto-fill, minmax(48%, 2fr))",
};

export const sharedAnchorAsButtonCss = [
  {
    color: colors.ui.white[700],
    padding: 0,
    height: "48px",
    width: "100%",
    textDecoration: "none",
    "> div": {
      width: "100%",
      display: "grid",
      gridTemplateAreas: `
      "icon provider"
    `,
      alignItems: "center",
      gridTemplateColumns: "auto 1fr",
    },
  },
  heading5Obj,
];

export const googleAnchorCss = {
  color: colors.ui.neutral[500],
  backgroundColor: colors.ui.white[700],
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25);",
};

export const googleIconCss = {
  marginLeft: "8px",
};

export const cleverAnchorCss = {
  backgroundColor: cleverBGColor,
};

export const canvasAnchorCss = {
  backgroundColor: canvasBGColor,
};

export const classlinkAnchorCss = {
  backgroundColor: classlinkBGColor,
  svg: {
    marginLeft: "4px",
  },
};

export const providerIconCss = [
  {
    gridArea: "icon",
    marginLeft: "16px",
    width: "100%",
    maxWidth: "unset",
  },
];

export const providerTextCss = {
  gridArea: "provider",
  textAlign: "center",
};
